import * as yup from 'yup';

export const schema = yup.object({
  des_cc: yup.string().trim().required(),
  des_agencia: yup.string().trim().required(),
  dta_saldo_inicial: yup.string().required(),
  cod_banco: yup.object().shape({
    label: yup.string().required(),
    value: yup.number().required(),
  }),
});
